// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"82885c66","315":"317e6e2f","378":"93d6aac7","415":"9887daa1","446":"154e20fc","812":"15257083"}[chunkId] + ".chunk.js";
};